"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getCollectionOffers } from "../api";
import type { CollectionOffersResponse } from "../types";

/**
 * `GET /collections/{contract}/offers` — supports `limit`/`page`. Mounted by
 * `OffersTab` (`CollectionDetailClient.tsx`), wired into `CollectionTabs`.
 *
 * `placeholderData` keeps the previous page's rows on screen while a new page
 * loads, which is also why a page-change failure does not surface through
 * `isError` — see the retry note on `OffersTab` (D049/D054).
 */
export function useCollectionOffers(contractAddress, lang, params) {
  const $ = _c(10);
  const limit = params?.limit;
  const page = params?.page;
  let t0;
  let t1;
  if ($[0] !== contractAddress || $[1] !== lang || $[2] !== limit || $[3] !== page) {
    t0 = ["collection-offers", contractAddress, lang, limit, page];
    t1 = () => getCollectionOffers(contractAddress, {
      limit,
      page
    }, lang);
    $[0] = contractAddress;
    $[1] = lang;
    $[2] = limit;
    $[3] = page;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  const t2 = params?.enabled !== false && Boolean(contractAddress);
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      placeholderData: _temp,
      staleTime: 15000
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return useQuery(t3);
}
function _temp(previous) {
  return previous;
}